import { ImageBackground } from 'components/common';

interface BannerImageProps {
  image: { src: string; alt: string };
  children: React.ReactNode;
}

const BannerImage = ({ image, children }: BannerImageProps) => {
  return (
    <ImageBackground
      src={image.src}
      alt={image.alt}
      priority
      style={{
        top: 0,
        left: 0,
        bottom: 0,
        backgroundColor: '#b6b6b5',
      }}
      objectPosition="center center"
    >
      {/* @ts-ignore */}
      {children}
    </ImageBackground>
  );
};

export default BannerImage;
